/*
 * Don Castor: módulo de ficha de producto (opciones elegidas, WhatsApp con madera y medida, barras fijas, pestañas). Lo carga sections/main-product.liquid.
 * Parte de dc-ui.js separada para no cargarla en las páginas que no la usan.
 */
(function () {
  'use strict';
  /* Una sola inicialización aunque el script se inserte varias veces (vista rápida de Dawn) */
  if (window.__dcProduct) return;
  window.__dcProduct = true;

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function store(kind, key, value) {
    try {
      var s = window[kind];
      if (value === undefined) return s.getItem(key);
      if (value === null) s.removeItem(key); else s.setItem(key, value);
    } catch (e) { return null; }
  }

  /* --- Producto: opciones elegidas, WhatsApp con madera y medida, barras fijas --- */
  function selectedOptions(scope) {
    var values = {};
    $$('[data-option-name]', scope).forEach(function (group) {
      var name = group.dataset.optionName;
      var checked = $('input:checked', group);
      var select = $('select', group);
      if (checked) values[name] = checked.value;
      else if (select) values[name] = select.options[select.selectedIndex] ? select.options[select.selectedIndex].text.trim() : select.value;
    });
    return values;
  }
  function fillTemplate(tpl, values) {
    return tpl.replace(/\[([^\]]+)\]/g, function (m, key) { return values[key] || ''; }).replace(/\s{2,}/g, ' ').trim();
  }
  function refreshProductTemplates() {
    var scope = $('product-info') || document;
    var values = selectedOptions(scope);
    $$('[data-dc-wa-template]').forEach(function (a) {
      a.href = a.dataset.dcWaBase + encodeURIComponent(fillTemplate(a.dataset.dcWaTemplate, values));
    });
    $$('[data-dc-template]').forEach(function (el) {
      el.textContent = fillTemplate(el.dataset.dcTemplate, values);
    });
    var priceBox = $('product-info [id^="price-"] .price');
    var price = priceBox && (priceBox.classList.contains('price--on-sale')
      ? $('.price__sale .price-item--last', priceBox)
      : $('.price__regular .price-item--regular', priceBox));
    if (price) {
      $$('[data-dc-sticky-price]').forEach(function (el) { el.textContent = price.textContent.trim(); });
    }
  }
  /* PUB_SUB_EVENTS es un const global de Dawn (no cuelga de window) */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { window.setTimeout(refreshProductTemplates, 0); });
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest('variant-selects')) window.setTimeout(refreshProductTemplates, 50);
  });

  function mainSubmit() {
    return $('product-info product-form .product-form__submit') || $('product-form .product-form__submit');
  }
  document.addEventListener('click', function (e) {
    var proxy = e.target.closest('[data-dc-proxy-submit]');
    if (!proxy) return;
    var submit = mainSubmit();
    if (submit && !submit.disabled) submit.click();
    else if (submit) submit.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
  });

  /* Cantidad de la barra de compra: espejo del selector principal */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dc-qty]');
    if (!btn) return;
    var main = $('product-info quantity-input .quantity__button[name="' + (btn.dataset.dcQty === 'plus' ? 'plus' : 'minus') + '"]');
    if (main) main.click();
    window.setTimeout(function () {
      var input = $('product-info quantity-input .quantity__input');
      $$('[data-dc-qty-value]').forEach(function (el) { el.textContent = input ? input.value : '1'; });
    }, 30);
  });

  var stickyBuy = $('[data-dc-sticky-buy]');
  var buyRow = $('product-info .product-form__buttons') || $('product-info product-form');
  if (stickyBuy && buyRow && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      stickyBuy.classList.toggle('is-visible', visible);
      stickyBuy.setAttribute('aria-hidden', visible ? 'false' : 'true');
      stickyBuy.inert = !visible;
    }).observe(buyRow);
  }

  /* --- Pestañas accesibles --- */
  $$('[data-dc-tabs]').forEach(function (tabs) {
    var buttons = $$('[role="tab"]', tabs);
    function select(btn, focus) {
      buttons.forEach(function (b) {
        var on = b === btn;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(b.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) btn.focus();
    }
    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () { select(btn); });
      btn.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = buttons[(i + 1) % buttons.length];
        if (e.key === 'ArrowLeft') next = buttons[(i - 1 + buttons.length) % buttons.length];
        if (e.key === 'Home') next = buttons[0];
        if (e.key === 'End') next = buttons[buttons.length - 1];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });
  });

})();
